import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  position: 'relative',
  paddingBottom: '200',
  borderBottom: '1px solid {colors.border.subtle}',
  md: {
    marginInline: '0',
    padding: '0',
    border: 'none',
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 320px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
    minWidth: '320px',
  },
});

export const chevronContainerStyles = css.raw({
  position: 'absolute',
  top: 'zero',
  right: '200',
  padding: '{spacing.200} {spacing.400}',
});
